<template>
  <div class="closed-card">
    <div class="source-description">
      <div class="checkmark-holder">
        <img :src="require('@/assets/icons/v.svg')" class="checkmark">
      </div>
      <div class="left">
        <div class="card-title">{{ cardText }}</div>
        <div class="subtitle">{{ subtitle }}</div>
      </div>
    </div>

    <div v-if="accounts" class="source-accounts">
      <div class="seperator"/>
      <div class="account" v-for="(account, index) in orderedAccounts" :key="account.accountNumber" :class="{ excluded: account.isExcluded }">
        <span class="circle">{{ index + 1 }}</span>
        <span class="account-number">{{ typeof account === 'object' ? account.accountNumber : account }}</span>
        <span class="card-stars" v-if="type === 'card'">****</span>
        <span class="not-connected" v-if="account.isExcluded"> [ לא מחובר לתזרים ]</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ClosedCard',
  props: {
    cardText: String,
    subtitle: {
      type: String,
      default: '',
    },
    accounts: Array,
    type: String,
  },
  computed: {
    orderedAccounts() {
      return _.sortBy(this.accounts, account => !!account.isExcluded);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../scss/mixins';

  .closed-card {
    @include card;
    padding: 18px 0px;

    .source-description {
      display: flex;

      .left {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .card-title {
          @include card-title;
          margin-bottom: 5px;
        }
      }

      .checkmark-holder {
        margin: 0 19px 0 15px;
      }
    }

    .source-accounts {
      margin-top: 18px;

      .seperator {
        height: 1px;
        background: $riseup_gray_0;
        margin-top: 5px;
      }

      .account {
        height: 30px;
        padding-top: 15px;
        padding-right: 23px;

        .circle {
          display: inline-block;
          height: 16px;
          width: 16px;
          line-height: 18px;
          font-family: SimplerProBold;
          font-size: 8px;
          vertical-align: middle;
          text-align: center;
          border-radius:8px;
          color: $riseup_white;
          background: $riseup_green;
          margin-left: 12px;
          margin-bottom: 3px;
        }

        .account-number {
          font-size: 16px;
        }

        &.excluded {
          color: $riseup_gray_2;

          .circle {
            background: $riseup_gray_1;
          }
        }

        .not-connected {
          margin-right: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/ClosedCard.vue